var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.2,
    height: 30.2,
    viewBox: "0 0 30.2 30.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34291",
    "data-name": "Path 34291",
    d: "M18,8a5.833,5.833,0,1,0,5.833,5.833A5.833,5.833,0,0,0,18,8Zm0,10a4.167,4.167,0,1,1,4.167-4.167A4.167,4.167,0,0,1,18,18ZM18,3A15,15,0,1,0,33,18,15,15,0,0,0,18,3ZM9.667,26.641v-.307A3.333,3.333,0,0,1,13,23H23a3.333,3.333,0,0,1,3.333,3.333v.307a3.291,3.291,0,0,1-1.574,2.841,13.267,13.267,0,0,1-13.519,0A3.291,3.291,0,0,1,9.667,26.641ZM28,26.79v-.456a5,5,0,0,0-5-5H13a5,5,0,0,0-5,5v.456a13.333,13.333,0,1,1,20,0Z",
    transform: "translate(-3 -3)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.05baf91d1194a8d5bff407c864ed1e32.svg";
export { ForwardRef as ReactComponent };